export default {"src":"/_next/static/media/private-cloud-white.ed60d4fd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};